import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';
import { EventDispatcher } from '@opten/events/event-dispatcher';

import barba from '@barba/core';
import barbaCss from '@barba/css';

declare const Cookiebot: any;

@Component({ className: 'js-page-transition' })
export class PageTransitionComponent {
	static onPageChange = new EventDispatcher<HTMLElement>();

	// tslint:disable-next-line: max-func-body-length
	constructor(private element: HTMLElement) {
		// const _listeners = [];

		// window.EventTarget || (window.EventTarget = function () {});
		// EventTarget.prototype.addEventListenerBase =
		// 	EventTarget.prototype.addEventListener;
		// EventTarget.prototype.addEventListener = function (
		// 	type,
		// 	listener,
		// 	options?
		// ) {
		// 	_listeners.push({
		// 		target: this,
		// 		type: type,
		// 		listener: listener,
		// 		options: options,
		// 	});
		// 	if (this) {
		// 		this.addEventListenerBase(type, listener, options);
		// 	}
		// };

		// EventTarget.prototype.removeEventListeners = function (targetTypes) {
		// 	for (let index = 0; index != _listeners.length; index++) {
		// 		const item = _listeners[index];

		// 		const target = item.target;
		// 		const type = item.type;
		// 		const listener = item.listener;

		// 		if (
		// 			target == this &&
		// 			(Array.isArray(targetTypes)
		// 				? targetTypes.includes(type)
		// 				: type == targetTypes)
		// 		) {
		// 			this.removeEventListener(type, listener);
		// 		}
		// 	}
		// };

		if (hasClass(this.element, 'barba--init') === false) {
			barba.hooks.afterOnce(() => {
				addClass(this.element, 'barba--init');
			});
			barba.hooks.after((e) => {
				PageTransitionComponent.onPageChange.dispatch(e.next.container);
				if ('Cookiebot' in window) {
					Cookiebot.runScripts();
				}
			});
			barba.hooks.enter((data) => {
				const startAt = data.next.container.querySelector(
					'.js-page-transition-start-at'
				) as HTMLElement;
				if (startAt) {
					const pos = startAt.style.position;
					startAt.style.position = 'relative';
					const offset = startAt.offsetTop;
					startAt.style.position = pos;
					if (window.scrollY > offset) {
						window.scrollTo(0, offset);
					}
				} else {
					window.scrollTo(0, 0);
				}
			});
			// barba.hooks.beforeLeave(() => {
			// 	window.removeEventListeners(['resize', 'scroll']);
			// 	document.removeEventListeners(['resize', 'scroll']);
			// });
			barba.hooks.leave((data) => {
				return new Promise((resolve) => {
					if (
						data.current.namespace === 'page' &&
						data.next.namespace === 'page'
					) {
						resolve();
					}
					setTimeout(() => {
						resolve();
					}, 350);
				});
			});
			barba.use(barbaCss);
			barba.init({
				timeout: 10000,
				prevent: ({ el }) =>
					!!el.closest('.js-page-transition-prevent') ||
					!el.closest('.js-page-transition-start-at'),
				transitions: [
					{
						name: 'slide-in',
						to: {
							namespace: ['page-slide'],
						},
						enter() {},
					},
					{
						name: 'slide-out',
						from: {
							namespace: ['page-slide'],
						},
						to: {
							namespace: ['page'],
						},
						enter() {},
					},
					{
						name: 'fade',
						from: {
							namespace: ['page'],
						},
						to: {
							namespace: ['page'],
						},
						enter() {},
					},
				],
				requestError: (trigger, action, url, response) => {
					// redirect to failed url (to show 404, 500 or just clean reload if timeout happend)
					return true;
				},
			});
		}
	}
}
